interface Request {
	legal: string;
	copyright: string;
}
export const footerText = (req: Request): string => `
${req.legal}

${req.copyright}
`;
